import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SkillsContainer from "../components/skills-container";
import ProjectCard from "../components/project-card";
import ContactContainer from "../components/contact-container";
import Pyramid1Image from "../components/pyramid1-image";
import "./portfolio12.css";

const Portfolio12 = () => {
  const navigate = useNavigate();

  const onProject2ContainerClick = useCallback(() => {
    window.open("https://dised.in/");
  }, []);

  const onSkillsTextClick = useCallback(() => {
    const anchor = document.querySelector("[data-scroll-to='frameContainer2']");
    if (anchor) {
      anchor.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }, []);

  const onProjectTextClick = useCallback(() => {
    const anchor = document.querySelector("[data-scroll-to='frameContainer1']");
    if (anchor) {
      anchor.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }, []);

  const onContactTextClick = useCallback(() => {
    const anchor = document.querySelector("[data-scroll-to='frameContainer']");
    if (anchor) {
      anchor.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }, []);

  const onIconFontAwesomeFreeSolidMClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  useEffect(() => {
    const scrollAnimElements = document.querySelectorAll(
      "[data-animate-on-scroll]"
    );
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            const targetElement = entry.target;
            targetElement.classList.add("animate");
            observer.unobserve(targetElement);
          }
        }
      },
      {
        threshold: 0.15,
      }
    );

    for (let i = 0; i < scrollAnimElements.length; i++) {
      observer.observe(scrollAnimElements[i]);
    }

    return () => {
      for (let i = 0; i < scrollAnimElements.length; i++) {
        observer.unobserve(scrollAnimElements[i]);
      }
    };
  }, []);

  const onFrameContainer4Click = useCallback(() => {
    window.open(
      "https://drive.google.com/file/d/12owpt-AIDrcxP1rbf3PUIKgcII6h_8PU/view?usp=sharing"
    );
  }, []);

  return (
    <div className="portfolio-12">
      <div className="left-eclipse-1" />
      <div className="right-eclipse-1" />
      <div className="right-eclipse-2" />
      <div className="left-eclipse-2" />
      <img
        className="supertoroid-yellow-glossy-icon1"
        alt=""
        src="/supertoroidyellowglossy@2x.png"
      />
      <img
        className="roundcube-orange-glossy-icon1"
        alt=""
        src="/roundcubeorangeglossy@2x.png"
      />
      <div className="ui1">
        <b className="hello-im-sayan-container">
          <p className="hello-im-sayan">Hello! I’m Sayan Das.</p>
          <p className="hello-im-sayan">
            <span>{`A UI/UX `}</span>
            <span className="designer">Designer</span>
            <span className="and">{` and `}</span>
          </p>
          <p className="gamer">Gamer</p>
        </b>
        <div className="enthusiastic-about-gaming">
          Enthusiastic about Gaming and UI/UX Design. Likes to build
          fast-performance and well-designed app interfaces using the latest
          technologies.
        </div>
        <div className="button1">
          <div className="button-child" />
          <div className="view-portfolio1">View Portfolio</div>
          <img
            className="iconfont-awesome-freesolidl1"
            alt=""
            src="/iconfont-awesome-freesolidllongarrowaltright.svg"
          />
        </div>
        <img className="saly-13-icon1" alt="" src="/saly13@2x.png" />
        <img
          className="supertoroid-purple-glossy-icon1"
          alt=""
          src="/supertoroidpurpleglossy@2x.png"
        />
        <div className="about-parent">
          <div className="about">About</div>
          <div className="skills" onClick={onSkillsTextClick}>
            Skills
          </div>
          <div className="skills" onClick={onProjectTextClick}>
            Project
          </div>
          <div className="skills" onClick={onContactTextClick}>
            Contact
          </div>
        </div>
        <img
          className="iconfont-awesome-freesolidm"
          alt=""
          src="/iconfont-awesome-freesolidmmoon.svg"
          onClick={onIconFontAwesomeFreeSolidMClick}
        />
        <SkillsContainer />
        <ProjectCard />
        <ContactContainer />
        <img
          className="multicolored-fluffy-arc-with-e"
          alt=""
          src="/multicolored-fluffy-arc-with-eyes@2x.png"
          data-animate-on-scroll
        />
        <div className="button-wrapper" onClick={onFrameContainer4Click}>
          <div className="button2" data-animate-on-scroll>
            <div className="button-item" />
            <div className="view-resume">View Resume</div>
          </div>
        </div>
        <b className="hello-im-sayan-container1" data-animate-on-scroll>
          <p className="hello-im-sayan">Hello! I’m Sayan Das.</p>
          <p className="hello-im-sayan">
            <span>{`A UI/UX `}</span>
            <span className="designer">Designer</span>
            <span className="and">{` and `}</span>
          </p>
          <p className="gamer">Gamer</p>
        </b>
        <div className="enthusiastic-about-gaming1" data-animate-on-scroll>
          Enthusiastic about Gaming and UI/UX Design. Likes to build
          fast-performance and well-designed app interfaces using the latest
          technologies.
        </div>
        <div className="passionate-uiux-designer" data-animate-on-scroll>
          Passionate UI/UX designer with a keen eye for aesthetics and
          user-centric design. Proficient in creating seamless, intuitive
          experiences that elevate digital products. Let my designs speak for
          themselves.
        </div>
        <div className="sayan-das-all-rights-reseved-parent">
          <div className="sayan-das-all-container">
            <span>{`© 2023 `}</span>
            <span className="sayan-das1">Sayan Das</span>
            <span> All Rights Reseved.</span>
          </div>
          <div className="designed-by-sayand24-container">
            <span>{`Designed by `}</span>
            <span className="sayand24">sayand24</span>
          </div>
        </div>
        <div className="group-parent">
          <div className="ellipse-parent">
            <div className="group-child" />
            <img className="figma-icon" alt="" src="/figma@2x.png" />
          </div>
          <div className="ellipse-parent">
            <div className="group-child" />
            <img
              className="figma-icon"
              alt=""
              src="/adobe-premiere-pro@2x.png"
            />
          </div>
          <div className="ellipse-parent">
            <div className="group-child" />
            <img className="figma-icon" alt="" src="/c-programming@2x.png" />
          </div>
          <div className="ellipse-parent">
            <div className="group-child" />
            <img className="figma-icon" alt="" src="/android-os@2x.png" />
          </div>
          <div className="ellipse-parent">
            <div className="group-child" />
            <img className="figma-icon" alt="" src="/python@2x.png" />
          </div>
          <div className="ellipse-parent">
            <div className="group-child" />
            <img className="figma-icon" alt="" src="/css3@2x.png" />
          </div>
        </div>
        <div className="group-container">
          <div className="ellipse-parent">
            <div className="group-child" />
            <img
              className="adobe-photoshop-icon"
              alt=""
              src="/adobe-photoshop@2x.png"
            />
          </div>
          <div className="ellipse-parent">
            <div className="group-child" />
            <img className="figma-icon" alt="" src="/java@2x.png" />
          </div>
          <div className="ellipse-parent">
            <div className="group-child" />
            <img className="figma-icon" alt="" src="/c@2x.png" />
          </div>
          <div className="ellipse-parent">
            <div className="group-child" />
            <img className="figma-icon" alt="" src="/html-5@2x.png" />
          </div>
          <div className="ellipse-parent">
            <div className="group-child" />
            <img className="figma-icon" alt="" src="/google-cloud@2x.png" />
          </div>
        </div>
        <div className="eclipse-parent">
          <div className="eclipse2" />
          <div className="group-child8" data-animate-on-scroll />
          <div className="sd">SD</div>
        </div>
      </div>
      <Pyramid1Image
        pyramid1ImagePyramid1="/pyramid-11@2x.png"
        pyramid1IconWidth="156.4px"
        pyramid1IconHeight="198.8px"
        pyramid1IconPosition="absolute"
        pyramid1IconTop="calc(50% + 496.5px)"
        pyramid1IconLeft="0px"
      />
      <img
        className="pill-blue-glossy-icon1"
        alt=""
        src="/pillblueglossy@2x.png"
        data-animate-on-scroll
      />
      <img
        className="sphere-white-matte-icon1"
        alt=""
        src="/spherewhitematte@2x.png"
      />
    </div>
  );
};

export default Portfolio12;
